
function ArrowLeft({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M19 12H5m6 7l-7-7 7-7" />
    </svg>
  );
}

function ArrowRight({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}

export default function CarouselControls({ onPrev, onNext }) {
  return (
    <div className="mt-6 flex items-center justify-center gap-4">
      <button
        aria-label="Previous"
        onClick={onPrev}
        className="h-[50px] w-[50px] mobile:h-[44px] mobile:w-[44px] tabletmini:h-[44px] tabletmini:w-[44px] rounded-full bg-white/10 hover:bg-white/50 
             hover:shadow-[0_0_12px_4px_rgba(255,255,255,0.25)] 
             border border-white/20 flex items-center justify-center"
      >
        <ArrowLeft className="h-6 w-6 mobile:h-4 mobile:w-4 tabletmini:h-4 tabletmini:w-4" />
      </button>

      <button
        aria-label="Next"
        onClick={onNext}
        className="h-[50px] w-[50px] mobile:h-[44px] mobile:w-[44px] tabletmini:h-[44px] tabletmini:w-[44px] rounded-full bg-white/10 hover:bg-white/50 hover:shadow-[0_0_12px_4px_rgba(255,255,255,0.25)] border border-white/20 flex items-center justify-center"
      >
        <ArrowRight className="h-6 w-6 mobile:h-4 mobile:w-4 tabletmini:h-4 tabletmini:w-4" />
      </button>
    </div>
  );
}
